import { triageV2 } from './triage';

export const getLocales = () =>
  triageV2({
    method: 'GET',
    url: '/graphs/locales',
  });
